<template>
  <div>
    <CustomCard
      :header="`GENERAL JOURNAL`"
      subHeader="List of all general journal.">
      <template v-slot:body>
        <Full
          @create="setCreate()"
          :noCreateButton="!isAccessible($options.GeneralJournalPermissions.ADD.id)"
          placeholder="Search Here..."
          :isServerSide="true"
          @search="loadGeneralJournals()"
          @paginate="loadGeneralJournals()"
          :filter="filters.generalJournal"
          :table="tables.generalJournals"
          :pagination="paginations.generalJournal"
          buttonLabel="Create New General Journal">
          <template v-slot:cell(action)="data">
            <b-dropdown
              boundary="window"
              right
              variant="link"
              toggle-class="text-decoration-none"
              no-caret>
              <template v-slot:button-content>
                <v-icon name="ellipsis-v" />
              </template>
              <b-dropdown-item
                v-if="isAccessible($options.GeneralJournalPermissions.EDIT.id)"
                @click="setUpdate(data.item)"
                :disabled="showModalEntry">
                Edit
              </b-dropdown-item>
              <b-dropdown-item
                v-if="isAccessible($options.GeneralJournalPermissions.DELETE.id)"
                @click="setDelete(data.item.id)"
                :disabled="showModalConfirmation">
                Delete
              </b-dropdown-item>
              <!-- <b-dropdown-item
                @click="onPreview(data.item.id)">
                Preview
              </b-dropdown-item> -->
            </b-dropdown>
          </template>
          <template v-slot:head(client) >
            <CustomToolTip id="client-icon" label="CLIENT">
              <template #body>
              <div>
                <div>Line 1 - Represents the client name.</div>
                <div class="row__sub-label">Line 2 - Represents the client code.</div>
              </div>
              </template>
            </CustomToolTip>
          </template>

          <template v-slot:cell(client)="data">
            <div>{{ data.item.client.name }}</div>
            <div class="row__sub-label">{{ data.item.client.code }}</div>
          </template>
        </Full>
      </template>
    </CustomCard>

    <GeneralJournalEntry
      v-if="showModalEntry"
      :show="showModalEntry"
      @onBack="showModalEntry=false"
      @save="onGeneralJournalEntry()"
      :mode="entryMode"
      :form="forms.generalJournal" />

    <DeleteConfirmation
      @close="showModalConfirmation = false"
      @yes="onGeneralJournalDelete()"
      :show="showModalConfirmation"
      :isProcessing="forms.generalJournal.isProcessing"
      name="General Journal" />
  </div>
</template>

<script>
import { CustomToolTip, CustomCard, CustomModal, DeleteConfirmation, SettingModal, AuthorizationModal } from "../../components";
import GeneralJournalEntry from './GeneralJournalEntry'
import { JournalEntryApi } from '../../../mixins/api';
import { GeneralJournalPermissions, JournalEntryTypes } from "../../../helpers/enum";
import Full from "../../components/Full";
import { clearFields, formatNumber, reset, showNotification, validate } from '../../../helpers/forms';
import { copyValue } from '../../../helpers/extractor';
import Access from '../../../mixins/utils/Access'

const generalJournalFields = {
  id: null,
  referenceNo: null,
  transactionDate: null,
  clientId: null,
  totalAmount: null,
  accountTitles: null,
  client: {
    name: null
  },
}

export default {
  components: {
    Full,
    GeneralJournalEntry,
    CustomToolTip,
    CustomCard,
    DeleteConfirmation,
    CustomModal,
  },
  mixins: [ JournalEntryApi, Access ],
  JournalEntryTypes,
  GeneralJournalPermissions,
  data() {
    return {
      rowLoading: false,
      showModalEntry: false,
      showModalBatchEntry: false,
      showSettingModal: false,
      entryMode: 'Add',
      showModalConfirmation: false,
      showModalAuthorization: false,
      billingPeriodStatus: true,
      isProcessing: false,
      forms: {
        generalJournal: {
          isProcessing: false,
          fields: { ...generalJournalFields },
          errors: { ...generalJournalFields },
          states: { ...generalJournalFields }      
        },
      },
      tables: {
        generalJournals: {
          isBusy: false,
          fields: [
            {
              key: 'referenceNo',
              label: 'REFERENCE NO',
              thClass: 'align-middle',
              thStyle: { width: '200px' },
            },
            {
              key: 'transactionDate',
              label: 'DATE',
              thClass: 'align-middle',
              thStyle: { width: '23%' },
            },
            {
              key: 'client',
              label: 'CLIENT',
              thClass: 'align-middle',
              thStyle: { width: 'auto' },
            },
            {
              key: 'totalAmount',
              label: 'AMOUNT',
              thClass: 'align-middle text-right',
              tdClass: 'text-right',
              thStyle: { width: '13%' },
              formatter: (value) => {
                return formatNumber(value)
              }
            },
            {
              key: 'action',
              label: '',
              thStyle: { maxWidth: '50px' },
              thClass: 'align-middle',
            },
          ],
          items: []
        }
      },
      paginations: {
        generalJournal: {
          from: 0,
          to: 0,
          totalRows: 0,
          page: 1,
          perPage: 10,
        }
      },
      filters: {
        generalJournal: {
          criteria: null,
        }
      },
      row: null
    }
  },
  created() {
    this.loadGeneralJournals()
  },
  methods: {
    loadGeneralJournals() {
      const { generalJournals } = this.tables
      const { generalJournal, generalJournal: { perPage, page } } = this.paginations
      const { id: journalEntryTypeId } = JournalEntryTypes.GENERAL_JOURNAL
      const { criteria } = this.filters.generalJournal
      const params = { paginate: true, perPage, page, journalEntryTypeId, criteria }
      generalJournals.isBusy = true
      this.getJournalEntryList(params).then(( { data } ) => {
        generalJournals.items = data.data
        generalJournal.from = data.meta.from
        generalJournal.to = data.meta.to
        generalJournal.totalRows = data.meta.total
        generalJournals.isBusy = false
      })
    },
    setCreate() {
      const { generalJournal, generalJournal: { fields } } = this.forms
      clearFields(generalJournal)
      reset(generalJournal)
      fields.cutoffDay = this.currentCutOffDay //set cutoff day

      fields.accountTitles = [{
        id: null,
        pivot: {
          memo: '',
          debit: 0,
          credit: 0
        }
      }]

      this.entryMode = "Add"
      this.showModalEntry = true
    },
    setUpdate(row) {
      const { generalJournal, generalJournal: { fields } } = this.forms
      clearFields(generalJournal)
      reset(generalJournal)
      fields.accountTitles = []
      this.getJournalEntry(row.id).then(( { data }) => {
        copyValue(data, fields)
        this.entryMode = "Edit"
        this.showModalEntry = true
      })
    },
    setDelete(id) {
      const { fields } = this.forms.generalJournal
      fields.id = id
      this.showModalConfirmation = true
    },
    onGeneralJournalEntry() {
      const {
        generalJournal,
        generalJournal: {
          fields: {
            referenceNo,
            client,
            accountTitles,
            ...fields
          }
        }
      } = this.forms
      generalJournal.isProcessing = true
      const accountTitlesData = accountTitles.map(c => {
        return {
          accountTitleId: c.id,
          memo: c.pivot.memo,
          debit: c.pivot.debit,
          credit: c.pivot.credit
        }
      })
      const data = {
        ...fields,
        totalAmount: accountTitles.reduce((total, item) => total += Number(item.pivot.debit), 0),
        journalEntryTypeId: JournalEntryTypes.GENERAL_JOURNAL.id,
        accountTitles: accountTitlesData,
      }
      reset(generalJournal)
      if (this.entryMode === 'Add') {
        this.addJournalEntry(data).then(({ data }) => {
          this.showModalEntry = false
          showNotification(this, "success", "General Journal created successfully.")
          generalJournal.isProcessing = false
          this.loadGeneralJournals()
        })
        .catch(error => {
          const errors = error.response.data.errors
          generalJournal.isProcessing = false
          validate(generalJournal, errors)
        })
      } else {
        this.updateJournalEntry(data, fields.id).then(({ data }) => {
          generalJournal.isProcessing = false
          this.showModalEntry = false
          showNotification(this, "success", "General Journal updated successfully.")
          this.loadGeneralJournals()
        })
        .catch(error => {
          const errors = error.response.data.errors
          generalJournal.isProcessing = false
          validate(generalJournal, errors)
        })
      }
    },
    onGeneralJournalDelete() {
      const { generalJournal, generalJournal: { fields: { id } } } = this.forms
      generalJournal.isProcessing = true
      this.deleteJournalEntry(id)
        .then(({ data }) => {
          this.loadGeneralJournals()
          generalJournal.isProcessing = false
          showNotification(this, "success", "General Journal deleted successfully.")
          this.showModalConfirmation = false
        })
        .catch(error => {
          const errors = error.response.data.errors
          generalJournal.isProcessing = false
          if(errors.msg) {
            showNotification(this, "danger", errors.msg)
          }
        })
    },
  },
}
</script>

<style lang="scss" scoped>
  .row__sub-label {
    font-size: 8pt!important;
    color: gray!important;
  }
  

</style>
